import { Button, Form, Input, Select, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Tank } from '@/types'
import { CreateDetergentRequest } from '@/types/apis/detergents/CreateDetergentRequest'

import { SpaceCustom } from '../../style'

type Props = {
  loading: boolean
  onSubmit: (formValues: CreateDetergentRequest) => void
  tanks: Tank[] | undefined
}

const { Title } = Typography

const CreateDetergentComponentForm = ({ loading, onSubmit, tanks }: Props) => {
  const { t } = useTranslation()

  return (
    <Form layout="vertical" onFinish={onSubmit}>
      <Form.Item
        label={t('components.pages.detergents.create.form.name')}
        name="name"
        rules={[{ required: true, message: t('components.pages.detergents.create.form.requireName') }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t('components.pages.detergents.create.form.price')}
        name="price"
        rules={[{ required: true, message: t('components.pages.detergents.create.form.requirePrice') }]}
      >
        <Input type="number" step={0.1} min={0} suffix="円" />
      </Form.Item>

      <Form.Item
        label={t('components.pages.detergents.create.form.netWeightG')}
        name="netWeightG"
        rules={[{ required: true, message: t('components.pages.detergents.create.form.requireNetWeightG') }]}
      >
        <Input type="number" min={0} suffix="g" />
      </Form.Item>

      <Form.Item
        label={t('components.pages.detergents.create.form.netWeightMl')}
        name="netWeightMl"
        rules={[{ required: true, message: t('components.pages.detergents.create.form.requireNetWeightMl') }]}
      >
        <Input type="number" min={0} suffix="ml" />
      </Form.Item>

      <Form.Item
        label={t('components.pages.detergents.create.form.specificGravity')}
        name="specificGravity"
        rules={[{ required: true, message: t('components.pages.detergents.create.form.requireSpecificGravity') }]}
      >
        <Input type="number" step={0.001} min={0} />
      </Form.Item>

      <Form.Item
        label={t('components.pages.detergents.create.form.costPerMl')}
        name="costPerMl"
        rules={[{ required: true, message: t('components.pages.detergents.create.form.requireCostPerMl') }]}
      >
        <Input type="number" step={0.00001} min={0} suffix="円" />
      </Form.Item>

      <Form.Item
        label={t('components.pages.detergents.create.form.remainingQuantity')}
        name="quantity"
        rules={[{ required: true, message: t('components.pages.detergents.create.form.requireRemainingQuantity') }]}
      >
        <Input type="number" min={0} suffix="ケース" />
      </Form.Item>

      <Form.Item
        label={t('components.pages.detergents.create.form.thresholdQuantity')}
        name="thresholdQuantity"
        rules={[{ required: true, message: t('components.pages.detergents.create.form.requireThresholdQuantity') }]}
      >
        <Input type="number" min={0} suffix="ケース" />
      </Form.Item>

      <Title level={4}>{t('components.pages.detergents.create.form.tankInfo')}</Title>
      <Form.Item label={t('components.pages.detergents.create.form.tankNo')} name="tankIds">
        <Select mode="multiple" style={{ border: '1px solid #ccc' }}>
          {tanks?.map((tank) => (
            <Select.Option key={tank.id} value={tank.id}>
              {tank.tankNo}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <SpaceCustom>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t('components.pages.machines.create.form.submit')}
          </Button>
        </Form.Item>
      </SpaceCustom>
    </Form>
  )
}

CreateDetergentComponentForm.displayName = 'CreateDetergentComponentForm'
export default CreateDetergentComponentForm
